module.exports = __webpack_public_path__ + "static/media/add award.cc4b647f.svg";